var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.39,
    height: 61.73,
    viewBox: "0 0 181.39 61.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{stroke-width:1.73px;}.d,.e{stroke:#000;stroke-miterlimit:10;}.e{stroke-width:1.77px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M30.88,60.86h-.02c-16.56,0-29.99-13.43-29.99-30S14.3,.87,30.87,.87s30,13.43,30,30-13.43,29.99-29.99,30Zm25.7-30C56.58,14.64,45.37,1.49,30.87,1.49S5.15,14.64,5.15,30.87s11.21,29.38,25.71,29.38,25.71-13.15,25.71-29.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M101.02,28.4v18.36c0,3.4,.25,6.8,.75,10.16h-3.06v-9.04c-1.46,5.8-6.79,9.86-13.54,9.86-8.99,0-15.29-5.93-15.29-14.43v-7.25h0v-7.62c0-3.4-.25-6.8-.75-10.16h3.82c-.5,3.36-.75,6.76-.75,10.16v15.45c0,7.99,5.15,13.33,12.8,13.33s13.68-5.48,13.68-12.51V26.5c-.08-2.77-.32-5.53-.72-8.27h3.82c-.5,3.36-.75,6.76-.75,10.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M138.82,26.68l-1.84,.98c-1.96-5.33-6.41-9.05-11.97-9.05-7.52,0-13.29,6.82-13.29,15.23v13.18c0,3.34,.25,6.67,.74,9.96h-3.74c.49-3.3,.74-6.63,.74-9.96v-13.18h0c0-8.59,6.96-15.55,15.55-15.55,6.01,0,11.21,3.41,13.8,8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M177.3,38.01h3.19c0,10.9-8.83,19.73-19.73,19.73s-19.73-8.83-19.73-19.73,8.83-19.73,19.73-19.73c7.62,0,14.22,4.32,17.51,10.64l-2.33,1.24h0l-30.46,16.21c2.68,6.48,8.42,10.96,15.28,10.96,9.54,0,16.54-8.65,16.54-19.32h0Zm-31.97,7.98l30.46-16.21c-2.55-6.55-8.12-11.09-15.03-11.09-9.54,0-16.91,8.65-16.91,19.32,0,2.85,.53,5.55,1.48,7.98Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 181.39,
    y1: 57.74,
    x2: 44.47,
    y2: 57.74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.42,54.49c-.12-.38-.25-.93-.33-1.34-.04-.23-.08-.45-.13-.66-.88-3.88-2.37-6.74-4.46-8.6-2.09-1.86-5.14-2.91-9.13-3.15-1.87-.12-3.46,0-4.76,.35-1.3,.35-2.33,.77-3.1,1.27-.77,.5-1.31,.94-1.61,1.32-.31,.38-.44,.54-.39,.49,.45-.55,1.09-1.04,1.89-1.47,.81-.43,1.78-.66,2.93-.71,2-.1,3.92,.64,5.74,2.21,1.83,1.57,3.9,4.08,6.23,7.52,1.5,2.38,2.71,3.88,3.66,4.75,1.31,1.37,2.69,1.81,8.47,1.27-3.06,.44-4.41-1.59-5.01-3.25Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.51790df5731d47fd93b38fe5ba732450.svg";
export { ForwardRef as ReactComponent };